/**
 * Number.prototype.format(n, x, s, c)
 *
 * @param integer n: length of decimal
 * @param integer x: length of whole part
 * @param mixed   s: sections delimiter
 * @param mixed   c: decimal delimiter
 */
Number.prototype.format = function (n, x, s, c) {
  var re = "\\d(?=(\\d{" + (x || 3) + "})+" + (n > 0 ? "\\D" : "$") + ")",
    num = this.toFixed(Math.max(0, ~~n));

  return (c ? num.replace(".", c) : num).replace(
    new RegExp(re, "g"),
    "$&" + (s || ",")
  );
};

/**
 * String.prototype.numeroToNumber(n)
 *
 * @param integer n: length of decimal
 */
String.prototype.numeroToNumber = function (n) {
  var num = this.replace(/[^0-9\.,\-]/g, "")
    .replace(/\./g, "")
    .replace(",", ".");
  if (n) num = Number(num).toFixed(n);
  return Number(num);
};

Number.prototype.numberToNumero = function () {
  return this.format(2, 3, ".", ",");
};

String.prototype.rsPrefix = function () {
  const p = window.intlGetCurrencySymbol();
  return p + " " + this;
};

/*
String.prototype.isValidDate = function () {
  if (this.length < 10) return false;
  else {
    var dataBR = this.substr(0, 10);
    var date = dataBR.split('/').reverse().join('-');
    return moment(date).isValid();
  }
};
*/

Array.prototype.max = function () {
  return Math.max.apply(null, this);
};

Array.prototype.min = function () {
  return Math.min.apply(null, this);
};

String.prototype.slugify = function () {
  return this.toString()
    .toLowerCase()
    .replace(/[àÀáÁâÂãäÄÅåª]+/g, "a") // Special Characters #1
    .replace(/[èÈéÉêÊëË]+/g, "e") // Special Characters #2
    .replace(/[ìÌíÍîÎïÏ]+/g, "i") // Special Characters #3
    .replace(/[òÒóÓôÔõÕöÖº]+/g, "o") // Special Characters #4
    .replace(/[ùÙúÚûÛüÜ]+/g, "u") // Special Characters #5
    .replace(/[ýÝÿŸ]+/g, "y") // Special Characters #6
    .replace(/[ñÑ]+/g, "n") // Special Characters #7
    .replace(/[çÇ]+/g, "c") // Special Characters #8
    .replace(/[ß]+/g, "ss") // Special Characters #9
    .replace(/[Ææ]+/g, "ae") // Special Characters #10
    .replace(/[Øøœ]+/g, "oe") // Special Characters #11
    .replace(/[%]+/g, "pct") // Special Characters #12
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(/[^\w\-]+/g, "") // Remove all non-word chars
    .replace(/\-\-+/g, "-") // Replace multiple - with single -
    .replace(/^-+/, "") // Trim - from start of text
    .replace(/-+$/, ""); // Trim - from end of text
};

String.prototype.isValidDateBr = function () {
  var matches = /^(\d{2})[-\/](\d{2})[-\/](\d{4})$/.exec(this);
  if (matches == null) return false;
  var d = matches[1];
  var m = matches[2] - 1;
  var y = matches[3];
  var composedDate = new Date(y, m, d);
  return (
    composedDate.getDate() == d &&
    composedDate.getMonth() == m &&
    composedDate.getFullYear() == y
  );
};

window.formataTempoPorSegundos = function (segundos, incluirSegundos) {
  if (!segundos) return "";

  if (typeof abreviado == "undefined") abreviado = false;

  segundos = Math.round(segundos);
  var hours = Math.floor(segundos / (60 * 60));

  var divisor_for_minutes = segundos % (60 * 60);
  var minutes = Math.floor(divisor_for_minutes / 60);

  var divisor_for_seconds = divisor_for_minutes % 60;
  var seconds = Math.ceil(divisor_for_seconds);

  var obj = {
    h: hours,
    m: minutes,
    s: seconds,
  };

  if (obj.h > 99) retorno = obj.h + ":" + pad(obj.m, 2) + ":" + pad(obj.s, 2);
  else retorno = pad(obj.h, 2) + ":" + pad(obj.m, 2) + ":" + pad(obj.s, 2);

  if (!incluirSegundos) retorno = retorno.substr(0, retorno.length - 3);

  return retorno;
};

/**
 * Recebe um arquivo e retorna uma promise que o retorna em base64
 * @param {*} file
 * @returns <string>Promise
 */
window.getBase64 = function (file) {
  var p = new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      resolve(reader.result);
    };
    reader.onerror = function (error) {
      reject(error);
    };
  });

  return p;
};

$.fn.isInViewport = function () {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();

  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  return elementBottom > viewportTop && elementTop < viewportBottom;
};

window.safeRound = function (value) {
  let rounded = _.round(value, 3);
  rounded = _.round(rounded, 2);
  return rounded;
};